import React from 'react'

import Heading from 'components/Luxkit/Typography/Heading'
import styled from 'styled-components'
import { rem } from 'polished'
import OfferTypesCarousel from 'home/components/BrowseOfferTypes/OfferTypesCarousel'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'

const TravelPane = styled(Group)`
  padding: ${rem(24)} 0;
  background: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} 0;
  }
`

function Travel() {
  return (
    <TravelPane direction="vertical" gap={20}>
      <LayoutContainer>
        <Heading variant="heading2">
          Everything travel, all in the one place
        </Heading>
      </LayoutContainer>
      <OfferTypesCarousel />
    </TravelPane>
  )
}

export default Travel
